<template>
  <v-card elevation="0">
    <v-card-title class="font-weight-regular">
      {{ $t('ADDRESSES.ITEMS') }}
      <v-spacer />
      <v-btn dark color="indigo" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('ADDRESSES.ITEM') }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <addresses-list
            v-bind="addressesListData"
            @refresh="getAddressesData"
            @update-params="updateParams"
            @view="view"
          />
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-expansion-panels v-model="linkedAddressesPanel" flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="text-h6 font-weight-regular">
                  <v-row>
                    <v-col md="auto">
                      {{ $t('LINKED_ADDRESSES.ITEMS') }}
                    </v-col>
                    <v-spacer />
                    <v-col md="auto">
                      <v-btn
                        dark
                        class="mr-4"
                        color="primary"
                        @click.stop="createLinked"
                      >
                        <v-icon left>mdi-plus</v-icon>
                        {{ $t('LINKED_ADDRESSES.LINK_ADDRESS') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <addresses-list
                    v-bind="addressesLinkedListData"
                    @refresh="getLinkedAddressesData"
                    @update-params="updateLinkedParams"
                    @view="viewLinked"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="800"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @removed="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import AddressesList, {
  BASE,
  LINKED
} from '@/modules/addresses/components/AddressesList';

export default {
  name: 'AddressesCard',

  components: {
    AddressesList,
    CreateAddress: () =>
      import('@/modules/persons/components/Addresses/CreateAddress'),
    ViewAddress: () =>
      import('@/modules/persons/components/Addresses/ViewAddress'),
    CreateLinkedAddress: () =>
      import(
        '@/modules/persons/components/Addresses/Linked/CreateLinkedAddress'
      ),
    ViewLinkedAddress: () =>
      import('@/modules/persons/components/Addresses/Linked/ViewLinkedAddress')
  },

  mixins: [i18nRefreshData],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      params: {},
      paramsLinked: {},
      addressesListData: {
        type: BASE,
        addresses: [],
        meta: {}
      },
      addressesLinkedListData: {
        type: LINKED,
        addresses: [],
        meta: {}
      },
      dialog: false,
      component: null,
      linkedAddressesPanel: false
    };
  },

  methods: {
    ...mapActions('person', ['getAddresses', 'getLinkedAddresses']),

    getAddressesData() {
      this.getAddresses({
        params: this.params,
        personId: this.personId
      }).then(({ data }) => {
        this.addressesListData.addresses = data.data;
        this.addressesListData.meta = data.meta;
      });
    },

    getLinkedAddressesData() {
      this.getLinkedAddresses({
        params: this.paramsLinked,
        personId: this.personId
      }).then(({ data }) => {
        this.addressesLinkedListData.addresses = data.data;
        this.addressesLinkedListData.meta = data.meta;
      });
    },

    updateParams(params) {
      this.params = params;
    },

    updateLinkedParams(params) {
      this.paramsLinked = params;
    },

    create() {
      this.dialog = true;
      this.component = {
        type: BASE,
        name: 'CreateAddress',
        data: {
          personId: this.personId
        }
      };
    },

    createLinked() {
      this.dialog = true;
      this.component = {
        type: LINKED,
        name: 'CreateLinkedAddress',
        data: {
          personId: this.personId
        }
      };
    },

    view(address) {
      this.dialog = true;
      this.component = {
        type: BASE,
        name: 'ViewAddress',
        data: {
          personId: this.personId,
          addressId: address.id
        }
      };
    },

    viewLinked(address) {
      this.dialog = true;
      this.component = {
        type: LINKED,
        name: 'ViewLinkedAddress',
        data: {
          personId: this.personId,
          addressId: address.id
        }
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      switch (this.component.type) {
        case BASE:
          this.refreshData();
          break;
        case LINKED:
          this.getLinkedAddressesData();
          break;
      }

      this.cancelDialog();
    },

    refreshData() {
      this.getAddressesData();
      this.getLinkedAddressesData();
    }
  }
};
</script>
